module.exports = __webpack_public_path__ + "e7370af0b885ed8fcbb91cc2c6a62794.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/middown-7.png
// module id = 2986
// module chunks = 0